"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __importDefault(require("./Box"));
var Coupons_1 = __importDefault(require("./Coupons"));
var Errors_1 = __importDefault(require("./Errors"));
var GroupDeliveryDay_1 = __importDefault(require("./GroupDeliveryDay"));
var Modals_1 = __importDefault(require("./Modals"));
var ProductDetails_1 = __importDefault(require("./ProductDetails"));
var DeliveryPoint_1 = __importDefault(require("./DeliveryPoint"));
var COMMON_WORDINGS = {
    SAV_LINK: {
        LINK: 'https://potagercity.my.site.com/serviceclient/s/contactsupport',
        FULL: '<a href="https://potagercity.my.site.com/serviceclient/s/contactsupport" class="underline">contacter le service client</a>',
    }
};
exports.default = {
    BOX: Box_1.default,
    COMMON: COMMON_WORDINGS,
    COUPONS: Coupons_1.default,
    DELIVERY_POINT: DeliveryPoint_1.default,
    ERRORS: Errors_1.default,
    GROUP_DELIVERY_DAY: GroupDeliveryDay_1.default,
    MODALS: Modals_1.default,
    PRODUCT_DETAILS: ProductDetails_1.default,
};
//# sourceMappingURL=index.js.map